import React from 'react';

const DateIcon = () => {
  return (
    <svg className="date-picker-icon" width="16" height="15" viewBox="0 0 16 15" xmlns="http://www.w3.org/2000/svg">
      <title>
        Date Icon
      </title>
      <path d="M.565 14.897h14.87a.56.56 0 0 0 .565-.57V1.624a.56.56 0 0 0-.565-.569h-2.798V.57A.56.56 0 0 0 12.072 0a.56.56 0 0 0-.565.57v.485H4.59V.57A.56.56 0 0 0 4.024 0a.56.56 0 0 0-.565.57v.485H.565a.56.56 0 0 0-.565.57V14.34c0 .306.262.556.565.556zM1.13 2.194h2.33v.305c0 .32.247.57.564.57a.56.56 0 0 0 .565-.57v-.305h6.918v.305c0 .32.248.57.565.57a.56.56 0 0 0 .565-.57v-.305h2.247v1.471H1.13V2.194zm0 2.61h13.74v8.968H1.13V4.804zm10.942 2.61h-8.13a.56.56 0 0 0-.566.569c0 .32.248.569.565.569h8.131a.56.56 0 0 0 .565-.57.56.56 0 0 0-.565-.568zm-4.065 2.748H3.94a.56.56 0 0 0-.565.57c0 .319.248.569.565.569h4.066a.56.56 0 0 0 .565-.57.56.56 0 0 0-.565-.569z" fill="currentColor" />
    </svg>
  );
};

export default DateIcon;
